import $ from 'jquery'
//import {Spinner} from 'spin.js';

// var opts = {
//   lines: 13, // The number of lines to draw
//   length: 38, // The length of each line
//   width: 17, // The line thickness
//   radius: 45, // The radius of the inner circle
//   scale: 1, // Scales overall size of the spinner
//   corners: 1, // Corner roundness (0..1)
//   speed: 1, // Rounds per second
//   rotate: 0, // The rotation offset
//   animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
//   direction: 1, // 1: clockwise, -1: counterclockwise
//   color: '#ffffff', // CSS color or array of colors
//   fadeColor: 'transparent', // CSS color or array of colors
//   top: '50%', // Top position relative to parent
//   left: '50%', // Left position relative to parent
//   shadow: '0 0 1px transparent', // Box-shadow for the lines
//   zIndex: 2000000000, // The z-index (defaults to 2e9)
//   className: 'spinner', // The CSS class to assign to the spinner
//   position: 'absolute', // Element positioning
// }
//
// window.view_more_dst2 = function(paged, term_id, action, selector, parent_selector = '', sort_by = '', taxonomy_type = null) {
//   if (taxonomy_type === null) {
//     taxonomy_type = $('#btn_' + selector).attr('data-taxonomy-type')
//   }
//
//   const data = {
//     'action': action,
//     'taxonomy_type': taxonomy_type,
//     'term_id': term_id,
//     'paged': paged,
//     'sort_by': sort_by,
//   }
//   console.log(data)
//
//   var target = null
//   if (parent_selector !== '') {
//     console.log('Parent Selector: ' + parent_selector)
//     target = document.getElementById(parent_selector);
//   } else {
//     console.log('Selector: ' + selector)
//     target = document.getElementById(selector);
//   }
//   /* eslint-disable */
//   var spinner = new Spinner(opts).spin(target);
//
//   const btn = 'btn_' + selector
//
//   console.log(data)
//   console.log('target: ' + target)
//   /* eslint-disable */
//   const url = dst_params.url
//   /* eslint-disable */
//
//   $.ajax({
//     url: url,
//     type: 'post',
//     data: data,
//     success: function (data) {
//        spinner.stop()
//       if (parent_selector !== '') {
//         $('#' + parent_selector).html(data)
//       } else {
//         $('#' + selector).html(data)
//         $('#' + btn).remove()
//       }
//     },
//     error: function (error) {
//       console.log(error)
//     },
//   })
// }


/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Main Ajax Trigger */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function ajax_content_loop_func(target,data,callback) {

  /* eslint-disable */
  const url = dst_params.url;
  /* eslint-disable */


  // Ajax to trigger more content
  $.ajax({
    url: url,
    type: 'post',
    data: data,
    success: function (response) {
      //console.log(response);

      // Load result - decide if to add to what is there or replace whats there from a filter
      // trigger callback code if any
      if(data.insert_type == 'replace') {
        $(target).html(response);
      } else {
        $(target).append(response);

      }
      if (typeof callback === 'function') {
        callback(response);

      }
    },
    error: function (error) {
      console.log(error)
    },
  })

}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Ajax Load More Button */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function ajax_load_more_trigger() {

  $('.ajax-load-more').each(function(){

    var $this = $(this);
    var parent = $(this).parent();
    var text = $this.html();

    jQuery($this).attr('data-btn-text',text);

    $($this).click(function(event){

      // loading button spinner effect
      $this.html('<div></div><div></div><div></div><div></div>');
      $this.addClass('btn-spinner');

      // Stop link from wanting to reload page
      event.preventDefault();

      // define data
      var target = parent.find('.ajax-list-wrap');
      var paged = parseInt(target.attr('data-paged'));
      const data = {
        'action': target.attr('data-action'),
        'taxonomy_type': target.attr('data-taxonomy-type'),
        'term_id': target.attr('data-term-id'),
        'paged': paged,
        'sort_by': target.attr('data-sort-by'),
        'insert_type': 'append',
        'ids': target.attr('data-ids')
      }

      ajax_content_loop_func(target,data,function(response){
        if(!$.trim(response) || $this.hasClass('click-once')) {
          // hide button when no more to load
          $this.hide();
          $this.css({'opacity':'0','height':'0px'});
        } else {
          // add 1 to paged
          paged++;
          target.attr('data-paged',paged);
          // reset button text
          $this.html(text);
          $this.removeClass('btn-spinner');
        }

      });

    });

  })

}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Ajax Select Filter  */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function ajax_sort_trigger() {

  $('.ajax-load-more').each(function() {

    var $this = $(this);
    var parent = $this.parent();
    var target = parent.find('.ajax-list-wrap');

    $(parent).find('select').change(function(){

      // Make sure load more button is visible incase its been hidden.
      $this.html($this.attr('data-btn-text'));
      $this.show();
      $this.css({'opacity':'1','height':'initial'});

      var selected = $(this);
      var value = this.value;
      var data = {
        'action': target.attr('data-action'),
        'taxonomy_type': target.attr('data-taxonomy-type'),
        'term_id': target.attr('data-term-id'),
        'paged': 1,
        'sort_by': target.attr('data-sort-by'),
        'insert_type': 'replace'
      }


      if(selected.attr('data-filter-type') == 'sort') {
        $.extend(data, {'sort_by':this.value});
      }
      if(selected.attr('data-filter-type') == 'taxo') {
        $.extend(data, {'term_id':this.value});
      }

      ajax_content_loop_func(target,data,function(){

        target.attr('data-paged',2);

        if(selected.attr('data-filter-type') == 'sort') {
          target.attr('data-sort-by',value);
        }
        if(selected.attr('data-filter-type') == 'taxo') {
          target.attr('data-term-id',value);
        }

      });


    });


  });

}



function destinationSlider() {

  if(jQuery('.list-where-to-go').length) {
    
    jQuery('.destination-slider-wrapper .destination-slider .list-where-to-go').each(function(){
      
      var $this = jQuery(this);
      var $parent = jQuery(this).parent().parent();
      var $status = jQuery($parent).find('.destination-slider-meta .count');

      $this.on('init reInit afterChange', function (event, slick, currentSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
      });

      $this.slick({
        centerMode: true,
        autoplay: true,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 2,
              centerMode: false,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerMode: false,
            }
          },
        ]
      });

      var $slides = $this.find('.loop-where-to-go').length;
      if($slides < 4){
        $this.slick('slickSetOption', 'centerMode', false);
        $this.addClass('centerFalse');
        jQuery($parent).find('.destination-slider-meta').hide();
      }

      jQuery($parent).find('.destination-slider-meta .prev').click(function() {
        jQuery($this).slick('slickPrev');
      });
      jQuery($parent).find('.destination-slider-meta .next').click(function() {
        jQuery($this).slick('slickNext');
      });


    });

  }

}


$(document).ready(function(){

  ajax_load_more_trigger();
  ajax_sort_trigger();

  // jQuery('.list-where-to-go').slick({slidesToShow: 3, responsive: [ { breakpoint:600, settings: { slidesToShow: 1} } ]});
  destinationSlider();

  jQuery('.target-mobile .list-holidays').slick();
  jQuery('.target-mobile .list-accommodations').slick();
  jQuery('.target-mobile .list-experiences').slick();
  jQuery('.target-mobile .list-articles').slick();

});



// WEBPACK FOOTER //
// ./scripts/partials/destinations/ajax.js